export default function canVisitStep(index, { isEditing, maxStepReached, isStepComplete }) {
  if (isEditing || index <= maxStepReached) return true;
  for (let earlier = 0; earlier < index; earlier += 1) {
    if (!isStepComplete(earlier)) return false;
  }
  return true;
}
